import { render } from "./SoftAlert.vue?vue&type=template&id=064e9bd8"
import script from "./SoftAlert.vue?vue&type=script&lang=js"
export * from "./SoftAlert.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__